import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './Columns.scss';

const Columns = (props) => {
  const layout = props.layout || 'equal';
  const { sb_style } = props;
  const classes = cn([
    'col_layout',
    `cl--${layout}`,
    sb_style ? `cl--sidebar_${sb_style}` : '',
    props.className,
  ]);
  return <div className={classes}>{props.children}</div>;
};

Columns.propTypes = {
  layout: PropTypes.oneOf(['equal', 'l_sidebar', 'r_sidebar']),
  sb_style: PropTypes.oneOf(['flex', 'fixed']),
};

export default Columns;
